<template>
  <div id="footer" class="container-fluid">
    <div class="content">
      <div class="logo">
        <img src="@/assets/images/logo2.png" alt="达人合作" />
      </div>
      <div class="footer-nav">
        <ul class="header-nav-wrapper">
          <li
            v-for="(item, index) in navList"
            :key="index"
            @click="navClick(index, item.name)"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <span
                v-if="item.children.length > 0"
                class="glyphicon glyphicon-menu-down"
              ></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length > 0">
              <dt v-for="(i, n) in item.children" :key="n">
                <router-link :to="i.path">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
        </ul>
        <p>Thwh777888@163.com</p>
      </div>
      <div class="code">
        <p style="margin-right: 20px">
          <img
            src="@/assets/images/code1.png"
            style="width: 80px; height: 80px"
            alt="代运营"
          />
          小程序
        </p>
        <p>
          <img
            src="@/assets/images/code2.jpeg"
            style="width: 80px; height: 80px"
            alt="合作共赢"
          />
          公众号
        </p>
      </div>
    </div>
    <div class="footer-a">
      <a href="https://tsm.miit.gov.cn/#/home" target="_blank" class="copy"
        >增值电信业务经营许可证：豫B2-20180486 |
      </a>
      <a
        href="http://gs.ccm.mct.gov.cn/lic/1df0ef85502e476fab06b7acf9cbb84c"
        target="_blank"
        class="copy"
        >豫ICP备2020029950号-2 &copy; | 豫网文〔2023〕4454-104号</a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      navList: [
        {
          name: "关于潮生",
          path: "/AboutUs",
          children: [],
        },
        {
          name: "多平台推广",
          path: "/Promotion",
          children: [],
        },
        {
          name: "行业动态",
          path: "/Dynamic",
          children: [],
        },
        {
          name: "一键分发",
          path: "/Distribute",
          children: [],
        },
        {
          name: "我们需要你",
          path: "/NeedYou",
          children: [],
        },
      ],
    };
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #1d2143;
  overflow: hidden;
  text-align: center;
}

#footer .content {
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  padding: 60px 0 30px;
  border-bottom: 1px solid #464d53;
}
#footer .footer-nav {
  width: 510px;
  text-align: left;
  opacity: 0.6;
}

/* 导航栏 每个导航 */
#footer .header-nav-wrapper {
  display: flex;
}
#footer .header-nav-wrapper > li {
  margin: 0 20px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#footer .header-nav-wrapper > li > a {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  padding: 15px 0;
  position: relative;
  cursor: pointer;
}
#footer .footer-nav p {
  font-size: 14px;
  font-weight: 400;
  margin: 0 20px;
}

.logo {
  width: 180px;
  height: 70px;
}
.logo img,
.code img {
  width: 100%;
}
.code {
  display: flex;
  align-items: start;
}
.code p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
  line-height: 30px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.copy {
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  margin: 20px 0;
  opacity: 0.6;
  display: inline-block;
}
@media screen and (max-width: 997px) {
  #footer .content {
    display: block;
    width: 100%;
  }
  .code {
    margin: 20px;
  }

  .copy {
    font-size: 12px;
    margin: 20px 0;
  }
}

.footer-a {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue